import React from 'react';
import { ArrowUpRight, ExternalLink } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLang } from '../contexts/LanguageContext';
type TradeKey = 'junkRemoval' | 'construction' | 'landscaping' | 'treeService' | 'irrigation' | 'poolPlaster';
type Project = {
  name: string;
  tradeKey: TradeKey;
  location: string;
  url: string;
  image: string;
};
const projects: Project[] = [{
  name: 'A and J Pool Plaster LLC',
  tradeKey: 'poolPlaster',
  location: 'aandjpoolplasterllc.com',
  url: 'https://aandjpoolplasterllc.com',
  image: 'https://image.thum.io/get/width/1200/crop/750/https://aandjpoolplasterllc.com'
}, {
  name: 'Javier Junk Removal',
  tradeKey: 'junkRemoval',
  location: 'javierjunkremoval.com',
  url: 'https://javierjunkremoval.com',
  image: 'https://image.thum.io/get/width/1200/crop/750/https://javierjunkremoval.com'
}, {
  name: 'Jezaway',
  tradeKey: 'junkRemoval',
  location: 'jezaway.com',
  url: 'https://jezaway.com',
  image: 'https://image.thum.io/get/width/1200/crop/750/https://jezaway.com'
}, {
  name: 'Blue Sky Contractor',
  tradeKey: 'construction',
  location: 'blueskycontractor.com',
  url: 'https://blueskycontractor.com',
  image: 'https://image.thum.io/get/width/1200/crop/750/https://blueskycontractor.com'
}, {
  name: 'Yeimateo Lawn Care',
  tradeKey: 'landscaping',
  location: 'yeimateolawncare.com',
  url: 'https://yeimateolawncare.com',
  image: 'https://image.thum.io/get/width/1200/crop/750/https://yeimateolawncare.com'
}, {
  name: 'Jose Junk Removal Service',
  tradeKey: 'junkRemoval',
  location: 'josejunkremovalservice.com',
  url: 'https://josejunkremovalservice.com/',
  image: 'https://image.thum.io/get/width/1200/crop/750/https://josejunkremovalservice.com/'
}, {
  name: 'South Coast Arbor Care',
  tradeKey: 'treeService',
  location: 'southcoastarborcare.com',
  url: 'https://southcoastarborcare.com',
  image: 'https://image.thum.io/get/width/1200/crop/750/https://southcoastarborcare.com'
}, {
  name: 'I and A Landscaping',
  tradeKey: 'landscaping',
  location: 'iandalandscaping.com',
  url: 'https://iandalandscaping.com',
  image: 'https://image.thum.io/get/width/1200/crop/750/https://iandalandscaping.com'
}, {
  name: 'North Face Irrigation',
  tradeKey: 'irrigation',
  location: 'northfaceirrigation.com',
  url: 'https://northfaceirrigation.com',
  image: 'https://image.thum.io/get/width/1200/crop/750/https://northfaceirrigation.com'
}];
export function PortfolioSection() {
  const {
    t
  } = useLang();
  return <section id="portafolio" className="py-24 bg-dark relative overflow-hidden" data-id="element-227" data-mp="3crgg7wnf3194">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[400px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-228" data-mp="1dfx5pdmgtkxc"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-229" data-mp="1ieqljcp85o0o">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-230" data-mp="1avr61i4vwgml">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gold/10 border border-gold/20 mb-6" data-id="element-231" data-mp="w74f0j5wa0fj">
            <span className="text-gold text-sm font-bold tracking-wide uppercase" data-id="element-232" data-mp="1ttbjlt277srw">
              {t.portfolio.badge}
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-233" data-mp="1jvdwj8w2s20v">
            {t.portfolio.title}{' '}
            <span className="text-gold" data-id="element-234" data-mp="1futz047lawe7">{t.portfolio.titleHighlight}</span>
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-235" data-mp="8h0bebspi0oj">
            {t.portfolio.subtitle}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-236" data-mp="4e41ral59ewq">
          {projects.map((project, index) => <motion.a key={index} href={project.url} target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="group relative rounded-3xl overflow-hidden border border-white/10 bg-dark-100 hover:border-gold/40 transition-all duration-300" data-id="element-237" data-mp="1satgqqoy367s" data-mpi={index}>
              {/* Mockup image */}
              <div className="relative aspect-[16/10] overflow-hidden" data-id="element-238" data-mp="2652tjfnra4kx">
                <img src={project.image} alt={`${t.portfolio.websiteAltPrefix} ${project.name}`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-239" data-mp="qkoaaybxloyo" />
                <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/30 to-transparent" data-id="element-240" data-mp="i5qp5d0e9wx1"></div>

                {/* Hover view button */}
                <div className="absolute top-4 right-4 w-11 h-11 rounded-full bg-gold text-dark flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-lg" data-id="element-241" data-mp="x1q2b22d2n91">
                  <ArrowUpRight className="w-5 h-5" data-id="element-242" data-mp="4bptwt8nis1f" />
                </div>
              </div>

              {/* Info */}
              <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-243" data-mp="e3dimmdtpuz7">
                <span className="inline-block text-xs font-bold uppercase tracking-wider text-gold bg-gold/10 border border-gold/20 px-3 py-1 rounded-full mb-3" data-id="element-244" data-mp="e5q95nxnddnv">
                  {t.portfolio.trades[project.tradeKey]}
                </span>
                <h3 className="text-2xl font-bold text-white mb-1 flex items-center gap-2" data-id="element-245" data-mp="3cu5mnl0tj771">
                  {project.name}
                  <ExternalLink className="w-4 h-4 text-gray-400 group-hover:text-gold transition-colors" data-id="element-246" data-mp="6blv19vwomy3" />
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-247" data-mp="abw08kbvj9bw">{project.location}</p>
              </div>
            </motion.a>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center mt-16" data-id="element-248" data-mp="k4bh1ebfprv7">
          <a href="https://wa.me/447311754270?text=WEBSITE" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-base font-bold rounded-full text-dark bg-gold hover:bg-gold-400 transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(212,175,55,0.3)]" data-id="element-249" data-mp="3nkscndygg6cb">
            {t.portfolio.cta}
          </a>
        </motion.div>
      </div>
    </section>;
}